import React from 'react';

function ArtifactsPage() {
  return (
    <div>
      <h1 className="product-page-title">Artifacts</h1>
      <p className="product-page-subtitle">
        Bake outputs are available from individual job detail pages.
      </p>
      <div className="product-card">
        <p className="mb-0 text-muted">
          A dedicated artifact browser will be added in a future slice. For now, open a completed
          job under Jobs to download artifacts you have access to.
        </p>
      </div>
    </div>
  );
}

export default ArtifactsPage;
